<template lang="pug">
.ride-container
  img.src(:src="imgUrl||'https://m.hellobike.com/resource/helloyun/22042/p4bBk_1125.png'")
  .wake-wechat-btn.flex-mid.btn(@click.capture="goRide")
    Scan(btnText="立即骑行")
</template>
<script>
import Scan from '@/pages/scan/components/scan.vue';
import Vue from 'vue';
import { setTitle } from '@/utils';
import { isPreRender } from '../../utils';
import { UBTUtils } from '../../utils/ubt';

Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-subscribe'];

export default {
  components: {
    Scan,
  },
  data() {
    return {
      type: null,
      openId: null,
      version: null,
      cityCode: null,
      cityName: null,
      command: null,
      title: null,
      imgUrl: null,
      skipGroup: '',
    };
  },
  created() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    this.init();
  },
  beforeDestroy() {
    const { group } = this.$route.query;
    UBTUtils.pageViewOut({
      pageId: 'wxkl2_zzy2',
      categoryId: 'platform',
      businessInfo: {
        openid: this.openId,
        trace: this.type,
        group,
        skipGroup: this.skipGroup,
        cityCode: this.cityCode,
        cityName: this.cityName,
      },
    });
  },

  methods: {
    init() {
      const {
        openId, type, version, cityCode, cityName, command, group, title, imgUrl, skipGroup,
      } = this.$route.query;

      if (openId) {
        this.openId = openId;
      }
      if (type) {
        this.type = type;
      }
      if (version) {
        this.version = version;
      }
      if (cityCode) {
        this.cityCode = cityCode;
      }
      if (cityName) {
        this.cityName = cityName;
      }
      if (command) {
        this.command = command;
      }
      if (title) {
        this.title = title;
      }
      if (imgUrl) {
        this.imgUrl = imgUrl;
      }
      if (skipGroup) {
        this.skipGroup = skipGroup;
      }
      setTitle(this.title || '哈啰骑行');
      UBTUtils.pageView({
        pageId: 'wxkl2_zzy2',
        categoryId: 'platform',
        businessInfo: {
          openid: openId,
          trace: type,
          groupId: version,
          cityCode,
          cityName,
          command,
          group,
          skipGroup,
        },
      });
      UBTUtils.moduleExpose({
        pageId: 'wxkl2_zzy2',
        categoryId: 'platform',
        moduleId: 'wxkl_zzyexpose',
        contentId: 'wxkl_zzyexpose',
        exposureTimes: 1,
        businessInfo: {
          trace: type,
          openid: openId,
          groupId: version,
          cityCode,
          cityName,
          command,
          group,
        },
      });
    },
    goRide() {
      const { group } = this.$route.query;
      UBTUtils.clickButton({
        pageId: 'wxkl2_zzy2',
        buttonName: 'wxkl_zzyexpose',
        categoryId: 'platform',
        businessInfo: {
          trace: this.type,
          openid: this.openId,
          groupId: this.version,
          cityCode: this.cityCode,
          cityName: this.cityName,
          command: this.command,
          group,
          skipGroup: this.skipGroup,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ride-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
  background-color: #fff;

  .src {
    width: 3.75rem;
    height: 3.75rem;
  }

  .subtitle {
    margin-bottom: 1.25rem;
    font-size: 0.18rem;
    font-weight: 600;
    color: #242729;
    line-height: 0.25rem;
  }

  .wake-wechat-btn {
    width: 3.11rem;
    height: 0.56rem;
    background: #08f;
    border-radius: 0.36rem;

    /deep/ .wechat-mp-button {
      position: relative;
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 0.48rem;

      .mp-button {
        background: transparent;
        color: #fff;
        line-height: 0.57rem;
        font-size: 0.2rem;
        font-weight: 500;
      }
    }
  }
}
</style>
